import React from 'react';
import SVGInline from "react-svg-inline";
import infoIcon from '../images/info-icon-info.svg';

const Help = ({helpDocLink}) => {

    if(!helpDocLink){
        return null;
    }
    return(
        <a className="help-doc-link" 
            href={helpDocLink}
            target="_blank"
            rel="noopener noreferrer"
        >
            <SVGInline svg={infoIcon}
                width='14'
                style={styles.iconStyle}
            />
        </a>
    )
    
};

const styles = {
    iconStyle: {
        marginLeft: "5px",
        cursor: "pointer", 
        color: "#4f7bff",
        display: 'inline-flex',
        verticalAlign: 'middle'
    }

};

export { Help };